import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { DashboardContent } from '../components/dashboard-content'
import { Fragment } from 'react/jsx-runtime'
import { Footer } from '../components/footer'
export default function Products() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="dashboard">
        <DashboardContent />
       </SidebarLayoutNew>
      <Footer />
    </Fragment>
  );
}